import React from "react";
import "./App.css";
import "react-tooltip/dist/react-tooltip.css";
import "bootstrap/dist/js/bootstrap.bundle";
import RadialBarChart from "../components/RadialBarChart";
import AssessmentSummary from "../components/AssessmentSummary";

function TestApp() {
  return (
    <>
      <h1>Lernstandserfassung Einleitung</h1>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "50px" }}>
        <table cellPadding={20}>
          <tr>
            <td style={{verticalAlign: "top", width: "50%"}}>
              <h2>Einfaches Diagramm</h2>
            </td>
            <td style={{verticalAlign: "top"}}>
              <h2>Ausführliches Diagramm</h2>
            </td>
          </tr>
          <tr>
            <td style={{verticalAlign: "top", background: "white"}}>
              <div style={{ maxWidth: 250 }}>
                <AssessmentSummary labels={["1. Zyklus", "2. Zyklus", "3. Zyklus"]} seriesCore={[87, 26, 2]} showDetailedSummary={false} renderLegend={true} height={200} />
              </div>
            </td>
            <td style={{verticalAlign: "top", background: "white"}}>
              <div style={{ maxWidth: 250 }}>
                <AssessmentSummary labels={["1. Zyklus", "2. Zyklus", "3. Zyklus"]} seriesCore={[87, 26, 2]} seriesPre={[95, 55, 20]} seriesPost={[30, 26, 0]} showDetailedSummary={true} renderLegend={true} height={200} />
              </div>
            </td>
          </tr>
          <tr>
            <td style={{verticalAlign: "top"}}>
              <p>An diesem bespielhaften Diagramm ist ersichtlich, dass der 1. Zyklus (orange) zu ca. 87% erreicht, der 2. Zyklus (blau) zu 26% erreicht und der 3. Zyklus bereits minimal angeschnitten wurde.</p>
            </td>
            <td style={{verticalAlign: "top"}}>
              <p>
                An diesem bespielhaften Diagramm ist ersichtlich, dass die Grundansprüche im 1. Zyklus (orange) zu ca. 87% erreicht sind. Die den Grundansprüchen vorangehenden Kompetenzstufen sind zu 95% erreicht und die weiterführenden
                Kompetenzstufen zu 30%. Im 2. Zyklus (blau) sind die Grundansprüche zu 26% erreicht, die vorangehenden Kompetenzstufen zu 55% und die weiterführenden Kompetenzstufen zu 20%. Der 3. Zyklus wurde bereits minimal angeschnitten.
              </p>
            </td>
          </tr>
        </table>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "50px" }}>
        <div style={{ maxWidth: 250 }}>
          <h1>Grundanspruch: 0% / 0 % / 0%</h1>
          <RadialBarChart Grundanspruch_Zyklus1={0} Grundanspruch_Zyklus2={0} Grundanspruch_Zyklus3={0} />
        </div>

        <div style={{ maxWidth: 250 }}>
          <h1>Grundanspruch: 100% / 50 % / 25%</h1>
          <RadialBarChart Grundanspruch_Zyklus1={100} Grundanspruch_Zyklus2={50} Grundanspruch_Zyklus3={25} />
        </div>

        <div style={{ maxWidth: 250 }}>
          <h1>Grundanspruch: 8.2% / 4.2 % / 9.5%</h1>
          <RadialBarChart Grundanspruch_Zyklus1={8.2} Grundanspruch_Zyklus2={4.2} Grundanspruch_Zyklus3={9.5} />
        </div>

        <div style={{ maxWidth: 250 }}>
          <h1>Vorangehende Ansprüche: 100% / 60% / 20%</h1>
          <h1>Grundanspruch: 90% / 50% / 10%</h1>
          <h1>Weiterführende Ansprüche: 50% / 30% / 5%</h1>
          <RadialBarChart
            Grundanspruch_Zyklus1={90}
            Grundanspruch_Zyklus2={50}
            Grundanspruch_Zyklus3={10}
            VorangehendeKompetenzstufen_Zyklus1={100}
            VorangehendeKompetenzstufen_Zyklus2={60}
            VorangehendeKompetenzstufen_Zyklus3={20}
            WeiterfuehrendeKompetenzstufen_Zyklus1={50}
            WeiterfuehrendeKompetenzstufen_Zyklus2={30}
            WeiterfuehrendeKompetenzstufen_Zyklus3={5}
          />
        </div>

        <div style={{ maxWidth: 150 }}>
          <h1>Grundanspruch: 8.2% / 4.2 % / 9.5%</h1>
          <RadialBarChart Grundanspruch_Zyklus1={8.2} Grundanspruch_Zyklus2={4.2} Grundanspruch_Zyklus3={9.5} />
        </div>

        <div style={{ maxWidth: 150 }}>
          <h1>Vorangehende Ansprüche: 100% / 60% / 20%</h1>
          <h1>Grundanspruch: 90% / 50% / 10%</h1>
          <h1>Weiterführende Ansprüche: 50% / 30% / 5%</h1>
          <RadialBarChart
            Grundanspruch_Zyklus1={90}
            Grundanspruch_Zyklus2={50}
            Grundanspruch_Zyklus3={10}
            VorangehendeKompetenzstufen_Zyklus1={100}
            VorangehendeKompetenzstufen_Zyklus2={60}
            VorangehendeKompetenzstufen_Zyklus3={20}
            WeiterfuehrendeKompetenzstufen_Zyklus1={50}
            WeiterfuehrendeKompetenzstufen_Zyklus2={30}
            WeiterfuehrendeKompetenzstufen_Zyklus3={5}
          />
        </div>

        <h1>AssessmentSummary mit dynamischer Legende</h1>
        <AssessmentSummary labels={["1. Zyklus", "2. Zyklus", "3. Zyklus"]} seriesCore={[90, 80.5, 50.1]} seriesPre={[70, 60.5, 30.1]} seriesPost={[50, 30.5, 1.1]} showDetailedSummary={true} renderLegend={false} height={200} />

        <h1>AssessmentSummary mit Legende</h1>
        <AssessmentSummary labels={["1. Zyklus", "2. Zyklus", "3. Zyklus"]} seriesCore={[90, 80.5, 50.1]} seriesPre={[70, 60.5, 30.1]} seriesPost={[50, 30.5, 1.1]} showDetailedSummary={true} renderLegend={true} height={200} />

        <h1>AssessmentSummary mit 0-Werten</h1>
        <AssessmentSummary labels={["1. Zyklus", "2. Zyklus", "3. Zyklus"]} seriesCore={[90, 80.5, 0]} seriesPre={[0, 60.5, 30.1]} seriesPost={[0, 0, 0]} showDetailedSummary={true} renderLegend={true} height={200} />
      </div>
    </>
  );
}

export default TestApp;
